const dev = {
  WEBAPP_URL: 'http://localhost:3000',
  API_URL: 'http://localhost:3333',
  DIRECT_API_URL: 'http://localhost:3333',
  CDN_URL: 'http://localhost:3336',
  OAUTH: {
    GOOGLE: {
      CLIENT_ID:
        process.env.NEXT_PUBLIC_GOOGLE_OAUTH_CLIENT_ID ||
        '858270128372-3cfonf26jglbf6n68hre9k3unslqoifp.apps.googleusercontent.com'
    }
  },
  GOOGLE_ANALYTICS_ID: 'G-XXXXXXXXXX',
  AMPLITUDE_API_KEY: '4e140c2723c8c96c4cd0c341e990e252',
  SENDREALM: {
    APP_ID: process.env.NEXT_PUBLIC_SENDREALM_APP_ID || 'ST4QUHZK',
    ENVIRONMENT: process.env.NEXT_PUBLIC_SENDREALM_ENVIRONMENT || 'development'
  },
  TRAKT_CLIENT_ID:
    '635c4bb2d4ec9668dabdbcd69139ca4ec3f3cb5ca25e728792ff64c7aa05cf00'
};

const prod = {
  WEBAPP_URL: 'https://trakio.app',
  API_URL: 'https://api.trakio.app',
  DIRECT_API_URL: process.env.NEXT_PUBLIC_DIRECT_API_URL,
  CDN_URL: 'https://static.trakio.app',
  OAUTH: {
    GOOGLE: {
      CLIENT_ID:
        process.env.NEXT_PUBLIC_GOOGLE_OAUTH_CLIENT_ID ||
        '507727283319-hnmr60tadm0j0ncqdje662s4e1iaicbn.apps.googleusercontent.com'
    }
  },
  GOOGLE_ANALYTICS_ID:
    'G-RT8CJNWMBY' || process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
  AMPLITUDE_API_KEY:
    '88b440f515f319486f1fb66eb1963f6d' ||
    (process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY as string),
  SENDREALM: {
    APP_ID: process.env.NEXT_PUBLIC_SENDREALM_APP_ID || 'ST4QUHZK',
    ENVIRONMENT: process.env.NEXT_PUBLIC_SENDREALM_ENVIRONMENT || 'production'
  },
  TRAKT_CLIENT_ID:
    '499c0978ae6b1c8f8283e72a0f1fe4d6dd7a4dfd827b9bab00b5760cf0b66dd7' ||
    process.env.NEXT_PUBLIC_TRAKT_CLIENT_ID
};

export default process.env.NODE_ENV === 'development' ? dev : prod;
